// extracted by mini-css-extract-plugin
module.exports = {"title":"SettungsInbox_title__3rOVA","alert":"SettungsInbox_alert__2IRAe"};